export default "/WebApp/dist/assets/images/speed.jpg";